import { createApiClient, createLocalStorageTokenStorage } from 'grabbitbot-legacy-ui'
import { API_BASE_URL } from '../config'

// One ApiClient + one token storage instance for the whole app — shared by
// AuthProvider, the payment client, and the screener domain client below.
// See grabbitbot-legacy-ui README "Wiring example".
export const tokenStorage = createLocalStorageTokenStorage('authToken')

export const apiClient = createApiClient({
  baseUrl: API_BASE_URL,
  getToken: () => tokenStorage.get(),
  onUnauthorized: () => tokenStorage.clear(),
})
